export default "__VITE_ASSET__B003Grjb__"